export default [{
  path: '/achivement/index',
  name: 'achivement-index',
  title: '业绩提成',
  component: () => import('@/views/achivement/index')
}, {
  path: '/detail/index',
  name: 'detail-index',
  title: '详情',
  component: () => import('@/views/achivement/template/detail/index')
}];
